import { useEffect, useState } from 'react';
import groupBy from 'lodash.groupby';
import {
  AccountsFlowsFormValues,
  ExpectedFundsOriginsFormValues,
} from '../../../../hoc/new-application/types';

const useStepOne = ({
  accountsFlowsValues,
  expectedFundsOriginsValues,
  sicCodes,
  countriesOfInterest,
  requiredCurrencies,
}: {
  accountsFlowsValues?: AccountsFlowsFormValues[];
  expectedFundsOriginsValues?: ExpectedFundsOriginsFormValues[];
  sicCodes?: string[];
  countriesOfInterest?: string[];
  requiredCurrencies?: string[];
}) => {
  const [sicCodesList, setSicCodesList] = useState<
    { name: string; id: string }[]
  >([{ name: '', id: '' }]);
  const [countriesOfInterestList, setCountriesOfInterestList] = useState<
    { name: string; id: string }[]
  >([{ name: '', id: '' }]);
  const [requiredCurrenciesList, setRequiredCurrenciesList] = useState<
    { name: string; id: string }[]
  >([{ name: '', id: '' }]);

  const groupedAccountsFlows = groupBy(
    accountsFlowsValues,
    (match) => match.currencyId,
  );

  const incomingExpectedFundsOfOrigins = expectedFundsOriginsValues?.filter(
    (item) => item.transactionType === 'INCOMING',
  );
  const outgoingExpectedFundsOfOrigins = expectedFundsOriginsValues?.filter(
    (item) => item.transactionType === 'OUTGOING',
  );

  useEffect(() => {
    if (sicCodes?.length) {
      setSicCodesList(sicCodes.map((item) => ({ name: item, id: item })));
    }
  }, [sicCodes]);

  useEffect(() => {
    if (countriesOfInterest?.length) {
      setCountriesOfInterestList(
        countriesOfInterest.map((item) => ({ name: item, id: item })),
      );
    }
  }, [countriesOfInterest]);

  useEffect(() => {
    if (requiredCurrencies?.length) {
      setRequiredCurrenciesList(
        requiredCurrencies.map((item) => ({ name: item, id: item })),
      );
    }
  }, [requiredCurrencies]);

  return {
    sicCodesList,
    setSicCodesList,
    countriesOfInterestList,
    setCountriesOfInterestList,
    requiredCurrenciesList,
    setRequiredCurrenciesList,
    groupedAccountsFlows,
    incomingExpectedFundsOfOrigins,
    outgoingExpectedFundsOfOrigins,
  };
};

export default useStepOne;
